// @flow
import type { CompareCustomAction } from "../types/compare_custom"

export const setAttributeCompare = (payload: array): CompareCustomAction => {
    return {
        type: "SET_ATTRIBUTE_COMPARE",
        payload,
    }
}

export const setCompareOptions = (payload: array): CompareCustomAction => {
    return {
        type: "SET_COMPARE_OPTIONS",
        payload,
    }
}

export const isInstall = (payload: boolean): CompareCustomAction => {
    return {
        type: "IS_INSTALL_APP",
        payload,
    }
}


export const isInstallAT = (payload: boolean): CompareCustomAction => {
    return {
        type: "IS_INSTALL_AT_APP",
        payload,
    }
}
